<div class="container">
    <div class="column-value">
        <div style="width: 100%">Old Value</div>
        {{fromValue}}
    </div>
    <div class="column-value">
        <div >New Value</div>
        {{toValue}}
    </div>
</div>